import { useDeleteEntityApi } from '@/common/api/deleteEntityApi';
import { usePackagingStore } from 'shared/packages/stores/packagingStore';

export function useDeletePackaging() {
  const store = usePackagingStore();

  return useDeleteEntityApi({
    url: 'packaging',
    translate: (t) => t.packaging.actions.delete,
    async processOk(request) {
      store.remove(request.id);
      return Promise.resolve({ ok: true });
    },
  });
}
